import React, { useState, useEffect } from "react";

import { Container, Row, Col } from "react-bootstrap";
import TradeRadarAlgoFbHowItWorks from "./TradeRadarAlgoFbHowItWorks/TradeRadarAlgoFbHowItWorks";
import FullyAutomate from "../../../src/Images/landing/Traderadar-Algo/Fully-Automate.png";
import TradeCharge from "../../../src/Images/landing/Traderadar-Algo/trade.png";
import SupportTeam from "../../../src/Images/landing/Traderadar-Algo/support.png";
import BacktestStrategies from "../../../src/Images/landing/Traderadar-Algo/backtest.png";
import Appstore from '../../Images/appstore.png';
import Playstore from '../../Images/playstore.png';
import TradeRadarAlgoFbHowItWork from "../../../src/Images/landing/Traderadar-Algo/TradeRadarAlgoFbHowItWork.png";
import "./TradeRadarAlgoFb.css";
import "../TradeRadarAlgoFb/TradeRadarAlgoFbWelcome/TradeRadarAlgoFbWelcome.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ApiUrlDomain } from "../Configration/Configrationnew";

function TradeRadarAlgoFbBlack() {
    const [num1, setNum1] = useState(0);
    const [num2, setNum2] = useState(0);
    const [userAnswer, setUserAnswer] = useState("");
    const [captchaError, setCaptchaError] = useState("");
    const navigate = useNavigate();
    const [mobile, setMobile] = useState("");
    const [email, setemail] = useState('');
    const [NameUser, setNameUser] = useState('');

    // Generate new captcha on mount
    useEffect(() => { generateCaptcha(); }, []);
    const generateCaptcha = () => {
        const a = Math.floor(Math.random() * 10); // Random number 0–9
        const b = Math.floor(Math.random() * 10);
        setNum1(a);
        setNum2(b);
        setUserAnswer("");
        setCaptchaError("");
    };

    const handleCaptchaChange = (e) => {
        const val = e.target.value.replace(/\D/g, ""); // allow only numbers
        setUserAnswer(val);
        setCaptchaError(""); // clear error while typing
    };

const handleSubmit = async (e) => {
  e.preventDefault(); // Prevent form from reloading

  // ✅ Validate mobile
  if (mobile.length !== 10) {
    alert("Mobile number must be exactly 10 digits.");
    return;
  }

  // ✅ Validate captcha
  const correctAnswer = num1 + num2;
  if (parseInt(userAnswer) !== correctAnswer) {
    setCaptchaError("Incorrect answer. Please try again.");
    return;
  } else {
    setCaptchaError("");
  }

  // ✅ Prepare data to send
  const bodydataleadapi = [
    { Attribute: "EmailAddress", Value: email },
    { Attribute: "Phone", Value: mobile },
    { Attribute: "mx_Primary_Email_ID", Value: email },
    { Attribute: "SearchBy", Value: "mx_Primary_Email_ID" },
    { Attribute: "Source", Value: "Website" },
    { Attribute: "FirstName", Value: NameUser },
    { Attribute: "mx_Vendor_Unique_Id", Value: "" },
    { Attribute: "mx_website_URL_React", Value: window.location.href },
  ];

  try {
    // ✅ Send data to API
    const response = await axios.post(
      "https://www.moneysukh.com/signupCreateLead",
      bodydataleadapi
    );

    if (response.status === 200) {
      navigate("/ThanksYou");
    } else {
     // alert("Something went wrong. Please try again.");
       navigate("/ThanksYou");
    }
  } catch (error) {
    console.error("API Error:", error);
    //alert("Failed to submit. Please check your connection and try again.");
    navigate("/ThanksYou")
  }
};


    const handleMobileChange = (e) => {
        const value = e.target.value;
        // Allow only digits and limit to 10
        const numericValue = value.replace(/\D/g, "").slice(0, 10);
        setMobile(numericValue);
    };


    const handleNameChange = (e) => {
        setNameUser(e.target.value);
    };

    const handleEmailChange = (e) => {
        setemail(e.target.value);
    };


    console.log("hhjgfhgfhj=====", NameUser, email, mobile)
    return (
        <>
            <main class="TradeRadarAlgoFbMain">
                <div className="stillwasting-section">
                    <div className="container">
                        <h5>Still wasting time in manual trading</h5>
                    </div>
                </div>
                <section id="bnrfrm" className="traderadaralgofbwelcomeblack_section">
                    <div class="container">
                        <div class="traderadaralgofbwelcomeblack-grid">
                            <div class="traderadaralgofbwelcomeblack-conts">
                                <h1><span>Automate your option trading</span> strategies with target & stoploss</h1>
                                <div class="traderadarAlgo-app">
                                    <a href="https://apps.apple.com/in/app/moneysukh-pro/id6739534241"><img src={Appstore}></img></a>
                                    <a href="https://play.google.com/store/apps/details?id=online.moneysukh.com&hl=en_IN"><img src={Playstore}></img></a>
                                </div>
                            </div>
                            <div class="traderadaralgofbwelcomeblack-formarea">
                                <h4>Get a free call with our expert</h4>
                                <div class="traderadaralgofbwelcomeblack-form">
                                    <form onSubmit={handleSubmit}>
                                        <div class="form-group">
                                            <label for="FirstName">First Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="FirstName"
                                                value={NameUser}
                                                onChange={handleNameChange}
                                                required
                                            />
                                        </div>
                                        <div class="form-group">
                                            <label for="exampleInputEmail1">Email address</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="Email"
                                                value={email}
                                                onChange={handleEmailChange}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Mobile</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="exampleInputEmail1"
                                                value={mobile}
                                                onChange={handleMobileChange}
                                                maxLength={10}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="quaze">{num1} + {num2}?</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="quaze"
                                                value={userAnswer}
                                                onChange={handleCaptchaChange}
                                                maxLength={2}
                                            />
                                            {captchaError && (
                                                <small className="form-text text-danger">{captchaError}</small>
                                            )}
                                        </div>

                                        <button type="submit" className="btn btn-primary">I want access </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="traderadarAlgo-feature">
                    <div className="container">
                        <div className="traderadarAlgofeature-grid">
                            <div className="traderadarAlgofeature-group">
                                <div className="traderadarAlgo-panel">
                                    <img src={FullyAutomate}></img>
                                    <h3>Fully Automate</h3>
                                    <p>Fully automate your daily trading strategies at no cost</p>
                                </div>
                            </div>
                            <div className="traderadarAlgofeature-group">
                                <div className="traderadarAlgo-panel">
                                    <img src={TradeCharge}></img>
                                    <h3>Trade</h3>
                                    <p>Rs.10 Per order only (No hidden charges)</p>
                                </div>
                            </div>
                            <div className="traderadarAlgofeature-group">
                                <div className="traderadarAlgo-panel">
                                    <img src={SupportTeam}></img>
                                    <h3>Support</h3>
                                    <p>Dedicated Support Team</p>
                                </div>
                            </div>
                            <div className="traderadarAlgofeature-group">
                                <div className="traderadarAlgo-panel">
                                    <img src={BacktestStrategies}></img>
                                    <h3>Backtest</h3>
                                    <p>Backtest your option strategies in seconds</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <TradeRadarAlgoFbHowItWorks />
                <section class="whychoose_section">
                    <div class="container">
                        <div class="section-heading center">Why <span>Choose</span> Moneysukh</div>
                        <div className="whychoose-grid">
                            <div className="whychoose-panel">
                                <h4>Flexible brokerage plans for Traders</h4>
                                <p>Triple benefits - Get instant pledge <br></br> benefits , trade at Rs 10 per order*,<br></br> complete tool kit.</p>
                            </div>
                            <div className="whychoose-panel">
                                <h4>Latest and secure Technology</h4>
                                <p>Cloud based & user-friendly platform <br></br>with latest features to help your<br></br> trading decisions.</p>
                            </div>
                            <div className="whychoose-panel">
                                <h4>Round the clock support</h4>
                                <p>Constant support and trade <br></br> with the help of dedicated<br></br> research.</p>
                            </div>
                        </div>
                        <div className="whychoose-img">
                            <img src={TradeRadarAlgoFbHowItWork}></img>
                        </div>
                    </div>
                </section>
                <section class="benefits_section">
                    <div class="container">
                        <div class="section-heading center">Benefits Of <span>Automated</span> Trading</div>
                        <div className="benefits-grid">
                            <div className="benefits-panel">
                                <h4>Trend</h4>
                                <p>Trades are executed on the basis of popular trend</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Index rebalancing</h4>
                                <p>Traders tend to focus on trades that’s have rebalancing effect</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Opportunity</h4>
                                <p>Track and trade the real opportunity arises in live markets</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Fast</h4>
                                <p>Trade execution at lightining speed</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Accuracy</h4>
                                <p>Trades get double checked to prevent any basic errors</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Emotions</h4>
                                <p>Automated trading makes your trading more decisive & emotions free</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Diversify</h4>
                                <p>Execute complex strategies with multiple time frame</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Cost</h4>
                                <p>Reduced transaction cost due to lack of human intervention</p>
                            </div>
                            <div className="benefits-panel">
                                <h4>Interface</h4>
                                <p>Simple and powerful UI</p>
                            </div>
                        </div>
                    </div>
                    <div className="bookdemo-section">
                        <div className="container">
                            <div className="bookdemo-inner">
                                <div className="bookdemo-grid">
                                    <h5> Explore More Features</h5>
                                    <a href="#bnrfrm"> Apply Now</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}
export default TradeRadarAlgoFbBlack;

